import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import withValueField from "../../Shared/withValueField";
import { errorToastr } from "../../../HelperMethods";
import { ErrorComponent } from "../../ReusableComponents";
import { LocalizationHelper } from "../../../Localization/helpers/LocalizationHelper";
import { LocalizationResource } from "../../Shared/AppConstants";

const CustomDropDownList = withValueField(DropDownList);
const defaultItem = { value: "Select..", text: null };

export interface MapModalProps {
    providerAddress: any;
    locationAddress: any;
    selectedMode: any;
    data?: any;
    onCloseModal: any;
    onOpenModal: any;
}

export interface MapModalState {
    origin:string;
    destination: string;
    distance: string;
    error: boolean;
}

class MapModal extends React.Component<MapModalProps, MapModalState> {
    private userClientLobId: any = localStorage.getItem("UserClientLobId");
    mapRef: React.RefObject<HTMLDivElement>;
    directionsService: google.maps.DirectionsService | null;
    directionsRenderer: google.maps.DirectionsRenderer | null;

    constructor(props: MapModalProps) {
        super(props);
        this.state = {
            origin: this.props.providerAddress,
            destination: this.props.locationAddress,
            distance: "",
            error: false
        };
        this.mapRef = React.createRef<HTMLDivElement>();

    }

    componentDidMount() {
        this.handleScriptLoad();
    }

    handleScriptLoad = () => {
        // Google Maps API loaded
        this.directionsService = new window.google.maps.DirectionsService();
        this.directionsRenderer = new window.google.maps.DirectionsRenderer({suppressMarkers: true});

        this.calculateDistance();
    }

    initMap = () => {
        const map = new window.google.maps.Map(this.mapRef.current, {
            center: { lat: 41, lng: -74 },
            zoom: 9,
          });
          this.directionsRenderer!.setMap(map);
        return map;
    };

    calculateDistance = () => {
        var map = this.initMap()
        const { providerAddress, locationAddress, selectedMode} = this.props;
        if (providerAddress == "" || providerAddress == undefined || locationAddress == "" || locationAddress == undefined){
            this.setState({error : true});
            return false;
        }

        if (providerAddress != "" && locationAddress != "") {
          
          if (this.directionsService) {
            const request = {
              origin: providerAddress,
              destination: locationAddress,
              travelMode: selectedMode,
            };
    
            this.directionsService.route(request, (result: any, status: any) => {
              if (status === window.google.maps.DirectionsStatus.OK) {
                this.setMapCustomMarker(map, result);
                const distance = result.routes[0]?.legs[0]?.distance.text;
                this.directionsRenderer!.setDirections(result);
                this.setState({distance})
              }else {
                if (this.directionsRenderer) {
                    const emptyDirectionsResult: google.maps.DirectionsResult = {
                        geocoded_waypoints: [],
                        routes: [],
                      };
                      this.directionsRenderer.setDirections(emptyDirectionsResult);
                }
                errorToastr("It Only Calculate Distance By Road");
              }
            });
          }
        }
      };

    setMapCustomMarker = (map, result) => {
        const { providerAddress, locationAddress} = this.props;

        new google.maps.Marker({
            position: result.routes[0]?.legs[0]?.end_location,
            label: "L",
            title: `${locationAddress}`,
            map: map
        });
        new google.maps.Marker({
            position: result.routes[0]?.legs[0]?.start_location,
            label: "P",
            title: `${providerAddress}`,
            map: map
        });
    }

    render() {
        const { origin, destination, distance, error } = this.state;
        return (
            <div className="row mt-0 ml-0 mr-0 mt-lg-0 align-items-center mb-0 d-flex justify-content-end map-job-catalog-width">
                <div className="modal-content border-0 modal-lg">
                    <div className="modal-header rounded-0 bg-blue d-flex justify-content-center align-items-center pt-2 pb-2">
                        <h4 className="modal-title text-white fontFifteen">
                            Map
                        </h4>
                        <button type="button" className="close text-white close_opacity" data-dismiss="modal" onClick={this.props.onCloseModal}>
                            &times;
                        </button>
                    </div>
                    <div className="row mt-2 mx-0 pl-2 pr-2">
                        <div className="col-5 mt-sm-0 mt-1 cal-icon-color">
                            <label className="mb-2 text-dark font-weight-bold">
                            Provider Address
                            </label>
                            <textarea
                                className="form-control area-textarea"
                                name="origin"
                                placeholder="Enter origin"
                                value={origin}
                                disabled={true}
                            ></textarea>
                        </div>
                        <div className="col-5 mt-sm-0 mt-1 cal-icon-color text-box-disbaled">
                            <label className="mb-2 text-dark font-weight-bold">
                            {LocalizationHelper.getLocalizedTitle(LocalizationResource.Location_Label, "Location")} Address
                            </label>
                            <textarea
                                className="form-control area-textarea"
                                name="destination"
                                placeholder="Enter destination"
                                value={destination}
                                disabled={true}
                            ></textarea>
                        </div>

                        <div className="col-2 mt-sm-0 mt-1 cal-icon-color text-box-disbaled">
                            <label className="mb-2 text-dark font-weight-bold">
                                Distance
                            </label>
                            <input
                                type="text"
                                className="form-control mr-2"
                                id="distance"
                                name="distance"
                                value={distance}
                                maxLength={100}
                                disabled={true}
                            />
                        </div>
                    </div>

                    <div className='border border-primary mt-3 mr-4 ml-4' ref={this.mapRef} style={{ height: '400px'}} />
                    <div className="pl-4">
                        {error && <ErrorComponent message={"Provider or "+LocalizationHelper.getLocalizedTitle(LocalizationResource.Location_Label, "Location")+" Address can not be blank."} />}
                    </div>
                    <div className="modal-footer justify-content-center border-0 mt-2 mb-2">
                        <div className="row mt-2 mb-2 ml-0 mr-0 justify-content-center">
                            <button type="button" className="btn button button-close mr-2 shadow mb-2 mb-xl-0" onClick={this.props.onCloseModal}>
                                <FontAwesomeIcon icon={faTimesCircle} className={"mr-1"} /> Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default MapModal;